"use client"

import { useParams } from "react-router-dom"
import { PageContainer } from "@/components/ui/page-container"
import { EmployerOrganisationSettingsRoutes } from "@/components/employer/employer-organisation-settings-routes"

export function EmployerOrganisationSettingsSlugLayout() {
  const { slug } = useParams<{ slug: string }>()
  const trimmed = slug?.trim()

  if (!trimmed) {
    return (
      <PageContainer maxWidth="4xl" className="py-10">
        <p className="text-sm text-muted-foreground">Missing organisation slug in the URL.</p>
      </PageContainer>
    )
  }

  return <EmployerOrganisationSettingsRoutes slug={trimmed} />
}
